import { CreateSchoolUserDTO, SchoolUserDTO } from './school-user-profile.dto';
import { RootState } from '../../../store/reducers';

export const selectCurrentSchoolUser = (state: RootState): CreateSchoolUserDTO | SchoolUserDTO => {
  return state.schools.user;
};
